export const PHOTOS_ITEM_TYPES = {
  PHOTO_TEMPLATES: 'photo_templates',
  PHOTO: 'photo',
};

export const EDITOR_QUERY_NAME = {
  template: 'template',
  image: 'imageId',
};
